import React, {useEffect, useState} from "react"
import { useObservable } from "thrive-observable-react";

//model
import {DownloadModel} from './Download.model'
import { SUACService } from "../../services/SignUpAppConfig.service";

//components
import { appStore, googlePlay} from "../../static";
import { ActionFeedback, ActionFeedbackBanner, BasicButton, IconLibrary, ThriveIcon } from "thrive-components";
import { useBeforeNavigateAway } from "thrive-components/hooks/useBeforeNavigateAway";

//hooks
import useNavigatorSetup from "../../utils/hooks/useNavigatorSetup";
import useScrollToTop from "../../utils/hooks/useScrollToTop";

//styling
import './download.scss';


const Download = () => {
    const [DM] = useState<DownloadModel>(new DownloadModel())
    const brandColor = useObservable<string>(SUACService.colour);
    const brandFontColor = useObservable<string>(SUACService.fontColour);
    const orgShortName = useObservable<string>(SUACService.orgShortName);
    const showBanner = useObservable<boolean>(DM.showErrorBanner);
    const QRCode = useObservable<string>(DM.QRCode)

    useNavigatorSetup();
    useBeforeNavigateAway(true);
    useScrollToTop();

    useEffect(() => {
        DM.setQrCode();
    },[])
    
    return (
        <div className="download-page page-container" style={{ "--brandColor": `#${brandColor}`, "--brandFontColor": brandFontColor } as React.CSSProperties}>
            <div className="download-container">
                <h1 className="download-heading">{DM.title}</h1>
                <h2 className="download-sub-heading">{DM.subtitle}</h2>

                <div className="step-container">
                    <div className="step-button">1</div>

                    <div className="step-information">
                        <h3 className="download-step">{DM.stepOneHeader}</h3>

                        <span className="download-instruction">{DM.stepOneInstructions}</span>

                        <div className="app-button-panel">
                            <button
                                className='app-store-button' 
                                onClick={DM.onAppStoreClick}
                                aria-label="Go to App Store"
                            >
                                <img 
                                    src={appStore} 
                                    alt="" 
                                />
                            </button>
                        
                            <button
                                className='google-play-button' 
                                onClick={DM.onGooglePlayClick}
                                aria-label="Go to Google Play Store"
                            >
                                <img 
                                    src={googlePlay} 
                                    alt="" 
                                />
                            </button>

                            <div className="qr-code-wrapper">
                                <img 
                                    className='qr-code' 
                                    src={QRCode}
                                    alt="QR code for app store" 
                                />
                                Scan to download
                            </div>
                        </div>
                    </div>
                </div>

                <div className="step-container">
                    <div className="step-button">2</div>
                    
                    <div className="step-information">
                        <h3 className="download-step">{DM.stepTwoHeader}</h3>
                        
                        <div className="org-information-panel">
                            <h4>YOUR ORGANISATION NAME</h4>

                            <span className="org-name">
                                {orgShortName}
                            </span>

                            <p className="org-instructions">
                                When you open the Thrive app for the first time, enter 
                                    <span className="org-name-background">
                                        <span>{orgShortName}</span> 
                                    </span>
                                as your Organisation name to access your customised workspace.
                            </p>
                        </div>
                    </div>
                </div>

                <div className="step-container">
                    <div className="step-button">3</div>
                    
                    <div className="step-information">
                        <h3 className="download-step">{DM.stepThreeHeader}</h3>
                        
                        <span className="download-instruction">{DM.stepThreeInstructions}</span>
                        
                        <BasicButton 
                            className="thrive-navigate-button"
                            onButtonClick={DM.onNavigateToCMSClick}
                            content={
                                <>
                                <ThriveIcon 
                                    iconName={IconLibrary.COMPUTER_EXTERNAL}
                                    color="var(--thriveCharcoal)"
                                    sizeInPx="14"
                                />
                                {DM.button}
                                </>
                            } 
                            ariaLabel={DM.button}
                        />
                    </div>
                </div>
            </div>

            
            {showBanner &&
                <ActionFeedbackBanner 
                    feedbackType={ActionFeedback.ERROR} 
                    feedbackMessage={"Something went wrong with log in"}
                />
            }
        </div>
    )
}

export default Download